import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
@Pipe({
  name: 'currency'
})
export class ReportCurrencyPipe implements PipeTransform {

  transform(value: number) {
   
    if (!value)  {
      value = 0;
    }
   let cc =  new CurrencyPipe('tr').transform(value, '₺')
    return new CurrencyPipe('tr').transform(value, '₺')
  }

}
